import { FormattedMessage } from "react-intl";
import { formatPlaceholder } from "../../../lib/formats/common";
import {
  type ActivityMetricFragment,
  ActivityMetricScope,
} from "../../../lib/graphql";
import {
  useActivityMetricScopeOptions,
  useMetricOptions,
} from "../../../lib/hooks/agro/metrics";
import { Form, shouldUpdate, useFormContext } from "../../form/Form";
import { SelectField } from "../../form/SelectField";
import { useItemSidebarContext } from "../../shared/ItemSidebar/Provider";
import { TableInput } from "../../shared/TableInput";

export function ActivityMetrics({ readonly }: { readonly?: boolean }) {
  const { form } = useFormContext();
  const { setCurrentAction } = useItemSidebarContext();
  const { options } = useActivityMetricScopeOptions();

  return (
    <Form.Item noStyle shouldUpdate={shouldUpdate("activityMetrics")}>
      {({ getFieldValue }) => {
        const activityMetrics: ActivityMetricFragment[] =
          getFieldValue("activityMetrics") || [];

        return (
          <TableInput
            name="activityMetrics"
            dataSource={activityMetrics}
            disabled={readonly}
            rowKey={(m) => m.metric.id}
            addIndexColumn
            hideEmpty
            tableSelectProps={{
              mode: "multiple",
              optionsHook: useMetricOptions,
              placeholder: formatPlaceholder({ id: "metrics.entityName" }),
              entityById(_, { metric }) {
                return {
                  id: "",
                  index: activityMetrics.length,
                  metric,
                  scope: ActivityMetricScope.CostCenter,
                };
              },
              newItemProps: {
                entityName: <FormattedMessage id="metrics.entityName" />,
                onClick: () => setCurrentAction("newMetric"),
              },
            }}
            draggable={{
              onDragFinish: (metrics) => {
                form.setFieldValue("activityMetrics", [...metrics]);
              },
            }}
            columns={[
              {
                title: <FormattedMessage id="metrics.entityName" />,
                render: (_, m) => m.metric.name,
              },
              {
                title: <FormattedMessage id="units.entityName" />,
                render: (_, m) => m.metric.unit.name,
              },
              {
                title: <FormattedMessage id="scope" defaultMessage="Scope" />,
                render: (_, _m, index) => (
                  <Form.Item name={["activityMetrics", index, "scope"]} compact>
                    <SelectField options={options} allowClear={false} />
                  </Form.Item>
                ),
              },
            ]}
          />
        );
      }}
    </Form.Item>
  );
}
